export default (global, browserNavigator) => {
  const UA = browserNavigator.userAgent;
  const isSafari = UA.indexOf('Safari') !== -1 && UA.indexOf('Chrome') === -1;

  if (isSafari && global.addEventListener) {
    global.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        global.location.reload();
      }
    });
  }
};
